import { render } from "./SellerSettingsTable.vue?vue&type=template&id=32b2be28&scoped=true"
import script from "./SellerSettingsTable.vue?vue&type=script&lang=js"
export * from "./SellerSettingsTable.vue?vue&type=script&lang=js"

import "./SellerSettingsTable.vue?vue&type=style&index=0&id=32b2be28&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b2be28"]])

export default __exports__